var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 7.29183V13.2418C25.6668 14.7235 25.1768 15.9718 24.3018 16.8352C23.4385 17.7102 22.1902 18.2001 20.7085 18.2001V20.3118C20.7085 21.1051 19.8218 21.5835 19.1685 21.1402L18.0368 20.3935C18.1418 20.0318 18.1885 19.6351 18.1885 19.2151V14.4669C18.1885 12.0869 16.6018 10.5002 14.2218 10.5002H6.30016C6.13682 10.5002 5.98516 10.5119 5.8335 10.5235V7.29183C5.8335 4.31683 7.81683 2.3335 10.7918 2.3335H20.7085C23.6835 2.3335 25.6668 4.31683 25.6668 7.29183Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1885 14.4667V19.215C18.1885 19.635 18.1418 20.0316 18.0368 20.3933C17.6052 22.1083 16.1818 23.1817 14.2218 23.1817H11.0485L7.52516 25.5267C7.00016 25.8883 6.30016 25.5033 6.30016 24.8733V23.1817C5.11016 23.1817 4.1185 22.785 3.43017 22.0967C2.73017 21.3967 2.3335 20.405 2.3335 19.215V14.4667C2.3335 12.25 3.71016 10.7217 5.8335 10.5234C5.98516 10.5117 6.13682 10.5 6.30016 10.5H14.2218C16.6018 10.5 18.1885 12.0867 18.1885 14.4667Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7fb593a2f3b28195e50c9891a32dea9e.svg";
export { ForwardRef as ReactComponent };